"use client";

import { Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LayoutContainer } from "components/Layout";

import { CurationProductsGridSkeleton, HeroImageSkeleton } from "@holibob-packages/ui-core/components";

export const CurationPageLoadingSkeleton = () => {
    return (
        <>
            <HeroImageSkeleton />
            <MainSectionContainer>
                <SubMainSectionContainer>
                    <Skeleton variant="text" width="50%" height={48} />
                    <Skeleton variant="text" height={87} width="30%" />
                </SubMainSectionContainer>
            </MainSectionContainer>
            <LayoutContainer>
                <CurationProductsGridSkeleton />
            </LayoutContainer>
        </>
    );
};

const MainSectionContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
}));

const SubMainSectionContainer = styled(LayoutContainer)(({ theme }) => ({
    padding: theme.airiness,
}));
